import ApplicationOverviewCard from './ApplicationOverviewCard'

const HistoryApplicationRenderer = ({ application, lang }) => {
  const historyApplication = application?.overviewMeta
    ? {
        ...application.overviewMeta,
        ...application,
      }
    : application

  return (
    <ApplicationOverviewCard
      job={historyApplication}
      lang={lang}
      allowActions={false}
    />
  )
}

export default HistoryApplicationRenderer
